import { cloneElement, HTMLAttributes, isValidElement } from 'react';
import { twMerge } from 'tailwind-merge';
import { ReactNode } from '@tanstack/react-router';
import { featuredIconStyles, FeaturedIconStyleVariants } from './variants';
import { match } from 'ts-pattern';

export type FeaturedIconProps = {
  icon: ReactNode;
  className?: string;
} & FeaturedIconStyleVariants &
  Omit<HTMLAttributes<HTMLDivElement>, 'className' | 'children' | 'color'>;

export function FeaturedIcon(props: FeaturedIconProps) {
  const {
    icon,
    size = 'md',
    variant = 'light-circle',
    color = 'primary',
    className,
    ...rest
  } = props;

  return (
    <div
      className={twMerge(
        featuredIconStyles({
          variant: variant,
          color: color,
          size,
        }),
        className,
      )}
      {...rest}
    >
      {icon && isValidElement(icon)
        ? cloneElement(icon, {
            className: twMerge(mapSizeToIconSize(size)),
          })
        : icon}
    </div>
  );
}

function mapSizeToIconSize(size: FeaturedIconStyleVariants['size']): string {
  return match(size)
    .returnType<string>()
    .with('xl', () => 'min-w-32 w-32 h-32')
    .with('lg', () => 'min-w-24 w-24 h-24')
    .with('md', () => 'min-w-20 w-20 h-20')
    .with('sm', () => 'min-w-16 w-16 h-16')
    .with('xs', () => 'min-w-12 w-12 h-12')
    .otherwise(() => 'min-w-20 w-20 h-20');
}
